import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Photos from './pages/Photos';
import Releases from './pages/Releases';
import Videos from './pages/Videos';
import Page from './pages/Page';
import ScrollToTop from './ScrollToTop';
//import { spring, AnimatedSwitch } from 'react-router-transition';

/*function mapStyles(styles) {
  return {
    opacity: styles.opacity,
    transform: `scale(${styles.scale})`,
  };
}

// wrap the `spring` helper to use a bouncy config
function bounce(val) {
  return spring(val, {
    stiffness: 330,
    damping: 22,
  });
}

// child matches will...
const bounceTransition = {
  // start in a transparent, upscaled state
  atEnter: {
    opacity: 0,
    scale: 1.2,
  },
  // leave in a transparent, downscaled state
  atLeave: {
    opacity: bounce(0),
    scale: bounce(0.8),
  },
  // and rest at an opaque, normally-scaled state
  atActive: {
    opacity: bounce(1),
    scale: bounce(1),
  },
};
*/
class Main extends Component {


  render() {
    return (
    <Switch>
    <Route exact path='/' component={Home} />

    <ScrollToTop  resChange={this.props.resChange} store={this.props.store}>

      <Route exact path='/about' component={About} />
      <Route exact path='/videos' render={(props) => (
        <Videos store={this.props.store} />
      )}/>
      <Route exact path='/photos' component={Photos} />
      <Route exact path='/contact' component={Contact} />
      <Route exact path='/releases' component={Releases} />
      <Route path='/page/:page' component={Page} />
    </ScrollToTop>

    </Switch>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Main.js